angular.module('env.data.httpInterceptors.xhrTracerInterceptor', [])

    .factory('xhrTracerInterceptor', function ($q, $log) {
        return {
            response: function (response) {
                if (response && response.config) {
                    $log.trace("%s %s -> %s %s", response.config.method, response.config.url, response.status, response.statusText);
                }
                return response;
            }
        };
    })

;